import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "./Shared";

export default function Footer() {
  const { user } = useAuth();
  return (
    <footer className="mt-16 border-t border-neutral-200 bg-white py-8">
      <div className="mx-auto max-w-6xl px-4 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex flex-col md:flex-row items-center gap-4">
          <p className="text-xs text-neutral-500">&copy; {new Date().getFullYear()} Vizcaya Labs LLC. All rights reserved.</p>
          <nav className="flex flex-wrap gap-3 justify-center items-center text-xs text-neutral-500">
            <Link to="/terms" className="hover:text-neutral-800">Terms of Service</Link>
            <Link to="/privacy" className="hover:text-neutral-800">Privacy Policy</Link>
            <Link to="/disclaimer" className="hover:text-neutral-800">Marketplace Disclaimer</Link>
            <Link to="/vendor-agreement" className="hover:text-neutral-800">Vendor Agreement</Link>
            <Link to="/refund" className="hover:text-neutral-800">Refund Policy</Link>
          </nav>
        </div>
        {user?.role !== 'customer' && (
          <Link to="/vendors/apply" className="text-sm font-medium text-[#2a7d4f] hover:text-[#236840] hover:underline whitespace-nowrap">
            Become a vendor →
          </Link>
        )}
      </div>
    </footer>
  );
}
